import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE } from '~/utils/constants/common';

import { IJobStatusList } from '~/utils/interface/job-status';
import { handleGetJobStatuses } from './jobStatusThunk';

export interface JobStatusState {
  selecJobStatuses: Array<IJobStatusList>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  jobStatuses: Array<IJobStatusList>;
  selectedIds: Array<string>;
  jobStatusId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: JobStatusState = {
  selecJobStatuses: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    // page: 1,
    limit: 0,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  jobStatuses: [],
  jobStatusId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const jobStatusSlice = createSlice({
  name: 'jobStatus',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeJobStatusId(state, action: PayloadAction<string>) {
      state.jobStatusId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetJobStatuses.pending, (_state, _action) => {})

      .addCase(handleGetJobStatuses.fulfilled, (state, action) => {
        state.jobStatuses = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetJobStatuses.rejected, (_state, _action) => {});
  },
});

export const jobStatusActions = jobStatusSlice.actions;

const jobStatusReducer = jobStatusSlice.reducer;
export default jobStatusReducer;
